import { VStack } from '@cad-arc';
export function TabBody(props: {
    children: React.ReactNode;
    constrainToParentHeight?: boolean;
}): React.ReactElement {
    return (
        <VStack
            height={props.constrainToParentHeight ? '100%' : undefined}
            alignItems="stretch"
            spacing={4}
        >
            {props.children}
        </VStack>
    );
}
